import { Default_getInstancejkv49nkel8hp as Default_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import {
  Companion_getInstance2dvnq0pgmsibf as Companion_getInstance,
  Messageyu2c6n5qdmq as Message,
} from './Message.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { System_instance3vgml03lwn0cv as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function formatMessage($this, _this__u8e3s4) {
  var tmp = Default_getInstance();
  var tmp_0 = Companion_getInstance().n29();
  var tmp0_safe_receiver = _this__u8e3s4.e2g_1;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap().hc(mapCapacity(tmp0_safe_receiver.v2()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = tmp0_safe_receiver.q3().u1();
    while (_iterator__ex2g4s.v1()) {
      var element = _iterator__ex2g4s.w1();
      var tmp_2 = element.r3();
      // Inline function 'kotlin.collections.component2' call
      var value = element.s3();
      var tmp$ret$2 = toString(value);
      destination.c5(tmp_2, tmp$ret$2);
    }
    tmp_1 = destination;
  }
  var tmp_3 = tmp_1;
  var tmp_4 = System_instance.gr().toString();
  var tmp1_safe_receiver = _this__u8e3s4.a2g_1;
  return tmp.e1o(tmp_0, new (Message())(_this__u8e3s4.z2f_1.a2_1, _this__u8e3s4.b2g_1, _this__u8e3s4.c2g_1, tmp_3, tmp_4, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g2g(), throwableToString($this, _this__u8e3s4.d2g_1)));
}
function appendToTestLog($this, message) {
  var logPath = typeof process !== 'undefined' && process.env ? process.env.COUPLING_TEST_LOG_PATH : null;
  if (logPath == null) {
    return Unit_instance;
  }
  var hasNode = typeof process !== 'undefined' && process.versions && process.versions.node;
  if (((!(hasNode == null) ? typeof hasNode === 'string' : false) ? hasNode : null) == null) {
    return Unit_instance;
  }
  try {
    var fs = require('fs');
    fs.appendFileSync(logPath, message + '\n');
  } catch ($p) {
    var _unused_var__etf5q3 = $p;
  }
}
function throwableToString($this, _this__u8e3s4) {
  if (_this__u8e3s4 == null) {
    return emptyList();
  }
  var msg = emptyList();
  var current = _this__u8e3s4;
  while (!(current == null) && !equals(current.cause, current)) {
    msg = plus(msg, ", Caused by: '" + current.message + "'");
    current = current.cause;
  }
  return msg;
}
var JsonFormatterClass;
function JsonFormatter() {
  if (JsonFormatterClass === VOID) {
    class $ {
      w2f(loggingEvent) {
        var message = formatMessage(this, loggingEvent);
        appendToTestLog(this, message);
        return message;
      }
      toString() {
        return 'JsonFormatter';
      }
      hashCode() {
        return -1288108928;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof JsonFormatter()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'JsonFormatter');
    JsonFormatterClass = $;
  }
  return JsonFormatterClass;
}
var JsonFormatter_instance;
function JsonFormatter_getInstance() {
  return JsonFormatter_instance;
}
//region block: init
JsonFormatter_instance = new (JsonFormatter())();
//endregion
//region block: exports
export {
  JsonFormatter_instance as JsonFormatter_instancevx3bw778eawd,
};
//endregion

//# sourceMappingURL=JsonFormatter.mjs.map
